<template>
  <v-dialog v-model="dialog" max-width="800px" persistent>
    <v-btn
      fixed
      fab
      bottom
      right
      color="primary"
      slot="activator"
    >
      <v-icon>add</v-icon>
    </v-btn>
    <v-card>
      <v-card-title>
        <span class="headline">Neue Veranstaltung erstellen</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12>
              <v-text-field label="Veranstaltungsfoto" @click='pickFile' v-model='imageName' prepend-icon='attach_file'>
              </v-text-field>
              <v-img
                v-if="imageUrl"
                :src="imageUrl"
                height="150"
                contain></v-img>
              <input type="file" @change="showThumbnail" ref="pictureInput" style="display: none" accept="image/*"/>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                label="Titel"
                required
                v-model="event.title"
                :disabled="loading"></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-textarea
                label="Beschreibung"
                required
                v-model="event.description"
                :disabled="loading"></v-textarea>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                label="Maximale Breite in Pixel (leer = maximum)"
                type="number"
                required
                v-model="event.maxWidth"
                :disabled="loading"></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                label="URL (leer = Bild öffnet sich beim klick)"
                required
                v-model="event.url"
                :disabled="loading"></v-text-field>
            </v-flex>
            <v-flex xs12 sm6>
              <v-menu
                ref="menu"
                :close-on-content-click="true"
                v-model="menu"
                :nudge-right="40"
                :return-value.sync="date"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="this.event.date"
                  label="Von"
                  readonly
                ></v-text-field>
                <v-date-picker
                  v-model="date"
                  scrollable
                  @input="$refs.menu.save(date)"
                  first-day-of-week="1"
                  locale="de-DE"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12 sm6>
              <v-menu
                ref="menuToDate"
                :close-on-content-click="false"
                v-model="menuToDate"
                :nudge-right="40"
                :return-value.sync="toDate"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="this.event.toDate"
                  label="Bis"
                  readonly
                ></v-text-field>
                <v-date-picker
                  v-model="toDate"
                  scrollable
                  @input="$refs.menuToDate.save(toDate)"
                  first-day-of-week="1"
                  locale="de-DE"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12>
              <v-checkbox
                v-model="event.hideItem"
                label="Nicht in der Aktivitätenübersicht anzeigen"
              ></v-checkbox>
            </v-flex>
          </v-layout>
        </v-container>
        <small>* Pflichtfelder</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click.native="save()" :loading="loading">Erstellen</v-btn>
        <v-btn color="error" @click.native="dialog = false; event = {}">Abbrechen</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// import { VueEditor } from 'vue2-editor';
import { mapActions } from 'vuex';


export default {
  name: 'DlgEventNew',
  components: {
  },
  data() {
    return {
      dialog: false,
      event: {},
      loading: false,
      date: null,
      toDate: null,
      menu: false,
      menuToDate: false,
      imageUrl: null,
      imageName: null,
    };
  },
  watch: {
    date(val) {
      this.event.date = this.formatDate(val);
    },
    toDate(val) {
      this.event.toDate = this.formatDate(val);
    },
  },
  methods: {
    ...mapActions({
      eventCreate: 'event/create',
      eventRead: 'event/read',
    }),
    save() {
      this.loading = true;
      this.eventCreate({ event: this.event, image: this.$refs.pictureInput.files[0] }).then((res) => {
        this.loading = false;
        if (res) {
          this.eventRead();
          this.event = {};
          this.dialog = false;
        }
      });
    },
    onChange() {
    },
    showThumbnail() {
      this.imageUrl = URL.createObjectURL(this.$refs.pictureInput.files[0]);
      this.imageName = this.$refs.pictureInput.files[0].name;
    },
    pickFile() {
      this.$refs.pictureInput.click();
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split('-');
      return `${day}.${month}.${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split('.');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
  },
};
</script>

<style scoped>

</style>
